<ng-container *ngFor="let attachedFiles of mappedAttachedFiles | keyvalue">
  <ng-container *ngIf="attachedFiles.key !== undefined">
    <span class="title">{{'proposalDetails.' + mapUploadLocation(attachedFiles.key) | translate}}</span>
    <app-download-files [attachedFiles]="attachedFiles.value"></app-download-files>
  </ng-container>
</ng-container>
